import service from '@/services/company-list/CompanyListService'

export const companyListModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    companyListsList: [],
    companyLists: {},
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 15,
    },
    headerList: [],
  },
  mutations: {
    SETCOMPANYLISTSLIST(state, payload) {
      state.companyListsList = payload.data
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
      state.pagination.per_page = parseInt(payload.per_page)
      state.headerList = []
    },
    SETCOMPANYLISTS(state, payload) {
      state.companyLists = payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },

  actions: {
    async getCompanyListsList({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getCompanyLists(payload)
        commit('SETCOMPANYLISTSLIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },

    async getCompanyListList(context, payload) {
      const response = await service.getCompanyList(payload)
      return response
    },

    async updateCompanyList({ dispatch, state }, payload) {
      const form = { ...payload.form }
      const { status } = await service.update(form, payload.id)

      dispatch('getCompanyListsList', { page: state.pagination.current_page })

      return status
    },

    async insertCompanyList({ dispatch, state }, payload) {
      const { status } = await service.insert(payload)
      dispatch('getCompanyListsList', { page: state.pagination.current_page })
      return status
      },
    
    async deleteCompanyList({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)
      dispatch('getCompanyListsList', { page: state.pagination.current_page })
      return status
    },
  },
}
